import { Chip } from "@mui/material";
import { useMemo } from "react";
import useCorClaraOuEscura from "../../../lib/useCorClaraOuEscura";

export default function SazonalidadeChip({ cores, nome }: SazonalidadeChipProps) {
    
    const luminosidade = useCorClaraOuEscura(cores || "#000");
    const corDaFonte = useMemo(() => {
        if (luminosidade === "clara") return "black"
        if (luminosidade === "escura") return "white"
    }, [luminosidade])

    return (
        <Chip
            variant="filled"
            label={nome}
            sx={{
                height: '19px',
                fontSize: '11px',
                paddingX: '0px',
                fontWeight: 'bold',
                backgroundColor: cores,
                color: corDaFonte,
                '& .MuiChip-label': {
                    padding: '0 4px',
                    height: '14px'
                },
            }}
        ></Chip>
    )
}

interface SazonalidadeChipProps {
    cores: string;
    nome: string;
}